import { useState } from "react";
import type { ClientFilters } from "../clientFilters";

interface UseDraftFilters {
  readonly draftFilters: ClientFilters;
  readonly updateDraft: (patch: Partial<ClientFilters>) => void;
}

/** Filters being edited in the form but not yet applied. Kept local to the form, so typing re-renders only the form,
 * not the client table. Re-syncs whenever the applied filters change from outside (a removed chip, a reset). */
export function useDraftFilters(appliedFilters: ClientFilters): UseDraftFilters {
  const [draftFilters, setDraftFilters] = useState(appliedFilters);
  const [syncedFilters, setSyncedFilters] = useState(appliedFilters);
  if (syncedFilters !== appliedFilters) {
    setSyncedFilters(appliedFilters);
    setDraftFilters(appliedFilters);
  }

  const updateDraft = (patch: Partial<ClientFilters>) => setDraftFilters((previous) => ({ ...previous, ...patch }));

  return { draftFilters, updateDraft };
}
